import { type ReactElement, type ReactNode } from 'react'
import { Group, TextInput } from '@mantine/core'
import { useTranslation } from '@front/model'
import { ButtonRefresh, TButton } from '../buttons'

type Props = {
  actions?: ReactNode
  filter: string
  onFilterChange: (filter: string) => void
  isChangedOnly: boolean
  onChangedOnlyChange: (isChangedOnly: boolean) => void
  refetch?: () => void
  isFetching?: boolean
  sticky?: boolean
}

const TOOLBAR = 'bg-body border-default-border border-b'
const STICKY_TOOLBAR = `${TOOLBAR} sticky top-0 z-20`

export const PermissionToolbar = ({
  actions,
  filter,
  onFilterChange,
  isChangedOnly,
  onChangedOnlyChange,
  refetch,
  isFetching,
  sticky = true,
}: Props): ReactElement => {
  const { t } = useTranslation()

  return (
    <Group className={sticky ? STICKY_TOOLBAR : TOOLBAR} gap='sm' py='sm' wrap='wrap'>
      <TextInput
        flex={1}
        miw={200}
        placeholder={t('Search Permissions')}
        value={filter}
        onChange={(e) => {
          onFilterChange(e.currentTarget.value)
        }}
      />
      <TButton
        buttonType='icon-rounded'
        icon='difference'
        tooltip={t('Only changed permissions')}
        variant={isChangedOnly ? 'primary' : 'secondary'}
        onClick={() => {
          onChangedOnlyChange(!isChangedOnly)
        }}
      />
      {actions}
      {refetch && <ButtonRefresh isFetching={isFetching} refetch={refetch} />}
    </Group>
  )
}
